import React, { useContext, useEffect, useState, useRef } from 'react'

import { FormControlLabel, Switch } from '@material-ui/core'
import Alert from 'react-bootstrap/Alert'
import { styled } from '@mui/material/styles';
import { Link, useParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import { Toast } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import permissionList from './permissionList';



const PermissionsManagement = ({userid}) => {
  const dispatch = useDispatch()
  useEffect(()=>{
    window.scrollTo(0,0)
    
    },[])
const loginnotif = useRef()
const {user} = useContext(AuthContext)

const params = useParams()
const user_id = userid?userid:params.user_id
const [key,setkey] = useState(null);
const [value,setvalue] = useState(false)

const [status,setstatus]= useState(false);
const [toast,settoast] = useState(false)


const [preferences,setpreferences] = useState(null)

const updatePreferences = async ({ key2, val }) => {
  dispatch({ type: 'LOADING' }); // Start loading state

  const formData = new FormData();
  formData.append('session', user.SessionId);
  formData.append("user_id", user_id);
  formData.append('key', key2);
  if (val === false) {
    formData.append('value', 0);
  } else {
    formData.append('value', 1);
  }

  try {
    const res = await axios.post(ENDPOINT + "update-team-permissions.php", formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });

    if (res?.data) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' }); // End loading state only on success
        setstatus(true);
        settoast(true);
        getPreferences();
        
   
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to update preferences'
        });
        setstatus(false); // Assuming false for error case
        settoast(true);
        getPreferences();
      }
    } else {
      dispatch({ 
        type: 'ERROR', 
        payload: 'Invalid response format'
      });
      setstatus(false); // Assuming false for error case

      getPreferences();
    }
  } catch (error) {


    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while updating preferences'
    });
    setstatus(false); // Assuming false for error case
    getPreferences();
  }
};
  


  const [searchTerm, setSearchTerm] = useState('');

const [pref,setpref] = useState(null)


const [account_login,setaccount_login] = useState(0)

//GET PREFERENCES
const getPreferences = async () => {
  dispatch({ type: 'LOADING' }); // Start loading state

  const formData = new FormData();
  formData.append('session', user.SessionId);
  formData.append("user_id", user_id);

  try {
    const res = await axios.post(ENDPOINT + "get-team-permissions.php", formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });

    if (res?.data) {
      if (res.data.status === "success" && res.data.data !== null) {
        dispatch({ type: 'DONE_LOADING' }); // End loading state only on success with data
        setpreferences(res.data.data);
        const data = res.data.data;
        setaccount_login(data.account_login);
        setpref(data);
        setstatus(true);
      } else if (res.data.status === "success" && res.data.data === null) {
        dispatch({ type: 'DONE_LOADING' }); // End loading state only on success (null data case)
        setpreferences(res.data.data);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to fetch preferences'
        });
      }
    } else {
      dispatch({ 
        type: 'ERROR', 
        payload: 'Invalid response format'
      });
    }
  } catch (error) {
  
    settoast(true);
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching preferences'
    });
  }
};


useEffect(()=>{
getPreferences()

},[])


    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
      ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: 2,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color:
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[600],
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22,
          marginleft:10,
          margintop:5
        },
        '& .MuiSwitch-track': {
          borderRadius: 26 / 2,
          backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
          opacity: 1,
          transition: theme.transitions.create(['background-color'], {
            duration: 500,
          }),
        },
      }));
      


  const filteredPermissions = permissionList.filter(
    (perm) =>
      perm.label.toLowerCase().includes(searchTerm.toLowerCase())
  );






    return (
     
<>

{preferences?
<>

<div className="container-fluid p-2">


<div className="position-fixed bottom-60 left-0 container-fluid justify-center">


<Toast className={status?"bg-warning":"bg-warning"} onClose={() => settoast(false)} show={toast} delay={3000} autohide>
         
         
         
       

          <Toast.Body>{status?"Changes Saved Successfully !":"Something went wrong !"}</Toast.Body>
          </Toast>
</div>


<div className="flex-wrap bg-white mb-5 pt-3 ">








<div className="col-lg-10 mx-auto mt-0">



{/*section starts*/}






{/*section ends*/}


{/*bharati section starts*/}




<div className="setting-section mt-5 p-2 w-100">
<h5>Permissions</h5>

{/* Search Bar */}
<div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search permissions..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

<div className="d-flex flex-wrap">
{filteredPermissions.map((perm) => (
                  <div
                    className="flex justify-content-between align-items-center  col-lg-6 col-md-6 col-12 col-l"
                    key={perm.key}
                  >
                    <div>
                      <p className="mb-0">{perm.label}</p>
                    </div>
                    <div>
                      <FormControlLabel
                        checked={preferences[perm.key] === "1"}
                        onChange={(e) =>
                          updatePreferences({
                            key2: perm.key,
                            val: e.target.checked,
                          })
                        }
                        control={<IOSSwitch sx={{ m: 1 }} color="primary" />}
                      />
                    </div>
                  </div>
                ))}
</div>
</div>
























</div>

{/* <div className="col-lg-5 pt-5 justify-center">
    <div className="w-50 text-center">
    <img src={preferences} className="w-100" alt=""></img>
    <p>If you'd like to learn more about privacy , you can read about it in the <Link to="/privacy-policy">Privacy Policy</Link></p>
    </div>
</div> */}



</div>




</div>

</>:

<>

</>

}


</>

    
    )
}

export default PermissionsManagement


